import logoutIcon from './image/logoutIcon.png';
import windowsIcon from './image/windowsIcon.png';
import macIcon from './image/macIcon.png';
import avalantLocation from './image/avalantLocation.png';
import navigation from './image/navigation.png';

export const settingIcon = {
  logoutIcon: logoutIcon,
  windowsIcon: windowsIcon,
  macIcon: macIcon,
  navigationIcon: navigation
}

export const location = avalantLocation;

export enum settingPage {
  GENERAL,
  VERIFICATION,
  CHANGE_PASSWORD,
  SECURITY,
  GROUP_PREFERENCE,
  LANGUAGE,
  ABOUT,
  REMOVE_ACCOUNT,
}

